var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-header text-left" },
    [
      _c(
        "ul",
        { class: "" + (_vm.isMobile ? "" : "nav justify-content-around") },
        [
          _c("li", [
            _c("b", { staticClass: "d-block" }, [_vm._v("Aereoporto")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.search.aereoporto ? _vm.search.aereoporto.label : "")
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", { staticClass: "d-block" }, [_vm._v("Partenza")]),
            _vm._v(" "),
            _c("span", { staticClass: "text-uppercase nowrap" }, [
              _vm._v(_vm._s(_vm.departureFormatted))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", { staticClass: "d-block" }, [_vm._v("Passeggeri:")]),
            _vm._v(" "),
            _c("span", { staticClass: "nowrap" }, [
              _vm._v(_vm._s(_vm.summaryText))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "after-icon-pen pr-0",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.onClickModify }
                },
                [_vm._v("Modifica")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("modal-change-search", {
        ref: "modalChangeSearch",
        on: { change: _vm.onChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc2df7fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc2df7fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/experience/layout/Header.vue
// module id = null
// module chunks = 